module.exports = __webpack_public_path__ + "fonts/iconfont.b4f3e433.ttf";